import { render } from "./ExpandingDiv.vue?vue&type=template&id=1fd00420&scoped=true"
import script from "./ExpandingDiv.vue?vue&type=script&lang=js"
export * from "./ExpandingDiv.vue?vue&type=script&lang=js"

import "./ExpandingDiv.vue?vue&type=style&index=0&id=1fd00420&scoped=true&lang=css"

import exportComponent from "C:\\Users\\hobbes\\Desktop\\abounddata-vue-frontend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1fd00420"]])

export default __exports__